import { Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import StatusMotoristaEnum from '../../../../../../Enum/StatusMotoristaEnum';
import { ModalInfo, ModalTitle } from '../styles';

const TagStatusDefaultForm = ({ status }) => (
  <>
    <Col>
      <ModalTitle>
        {`Você está atualizando o status do motorista para "${
          StatusMotoristaEnum.getTipo(status).label
        }"`}
      </ModalTitle>
      <ModalInfo regular>
        Ao clicar em confirmar não será possível desfazer a ação.
      </ModalInfo>
    </Col>
  </>
);

TagStatusDefaultForm.propTypes = {
  status: PropTypes.number.isRequired,
};

export default TagStatusDefaultForm;
